import Account from './AccountComponent';
import Result from './ResultComponent';

export default {
  Account,
  Result,
};



// WEBPACK FOOTER //
// ./src/components/plugins/index.js